import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, Button, Form } from 'react-bootstrap';

const EditUserModal = ({ show, handleClose, userData, handleSave }) => {
  const [formData, setFormData] = useState(userData);

  useEffect(() => {
    setFormData(userData);
  }, [userData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edit User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col lg={4} md={6} sm={6} xs={12}>
              <Form.Group controlId="formName">
                <Form.Label className="fw-bold">User Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name || ''}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col lg={4} md={6} sm={6} xs={12}>
              <Form.Group controlId="formEmail">
                <Form.Label className="fw-bold">Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email || ''}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col lg={4} md={6} sm={6} xs={12}>
              <Form.Group controlId="formRole">
                <Form.Label className="fw-bold">Role</Form.Label>
                <Form.Select
                  name="role"
                  value={formData.role || ''}
                  onChange={handleChange}
                >
                  <option value="">Select Role</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                  <option value="guest">Guest</option>
                </Form.Select>
              </Form.Group>

            </Col>
          </Row>
        </Form>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
        <Button variant="primary" onClick={() => handleSave(formData)}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditUserModal;
